import * as Sentry from '@sentry/react';

import { appEnv } from '@/app/config/env';

Sentry.init({
  enabled: import.meta.env.PROD,
  dsn: appEnv.sentryDSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/qua\.sgp\.globoi\.com/,
    /^https:\/\/dev\.sgp\.globoi\.com/,
    /^https:\/\/sgp\.entretenimento\.g\.globo\//,
    /^https:\/\/sgp-api\.entretenimento\.g\.globo\//,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
